import axios from 'axios';

const BASE_URL = '/api/canvas/suggest-next';

/**
 * Fetch AI-powered next-action suggestions for a canvas node.
 *
 * @param {Object} params
 * @param {string} params.nodeId        - Local node ID (cache key only)
 * @param {string} params.nodeType      - "text" | "image" | "fileNode" | ...
 * @param {string} params.nodeContent   - Node content
 * @param {Array}  params.pathHistory   - [{type, operation, summary}] ancestors (nearest first)
 * @param {string} [params.role]        - Active role key
 * @param {string} [params.domainHint]  - Optional domain hint
 * @param {Object} [params.fileContext] - For fileNode: {filename, mime_type, schema_preview, available_tools}
 * @returns {Promise<{suggestions: Array, ttl: number}>}
 */
export async function fetchCanvasSuggestions({ nodeId, nodeType, nodeContent, pathHistory = [], role, domainHint, fileContext }) {
  const response = await axios.post(
    BASE_URL,
    {
      node_id: nodeId,
      node_type: nodeType,
      node_content: nodeContent,
      path_history: pathHistory,
      role: role || null,
      domain_hint: domainHint || null,
      file_context: fileContext || null,
    },
    { timeout: 15000 }
  );

  return response.data;
}
